let url = (new URL(document.URL));
let host = url.hostname
export const domain = host.replace('auditoria.', '')

export const rootUrl = 'https://api.'+domain+'/'
export const apiUrl = 'https://api.'+domain+'/auditoria/'
export const SCROLL = 200
export const auth_id = 5
export const auth_secret = 'IvnrW38M0d8GMs96XG4xfZs03qlQXQafnoxCC1Rg'